const layouts = {}
const files = require.context('.', false, /^(?!.*(?:ignore)).*\.vue$/)

files.keys().forEach(key => {
  var name = key.replace('./', '').replace('/index.vue', '').replace('.vue', '')
  layouts[files(key).alias || name] = files(key)
})

export default layouts



// WEBPACK FOOTER //
// ./src/components/Layouts/index.js